import { View } from "binder"
import { ThemeSelectorViewModel } from "./themeSelector-viewModel"

export class ThemeSelectorView extends View<ThemeSelectorViewModel>{
    GetViewUniqueId(): string {
        return "V-98F790DD-5093-4CE0-BC05-36F22A51BAED"
    }
    loadHtml(): string {
        let element = require('./themeSelector.html').default;
        let style = require('./themeSelector.less');
        return element;
    }
    constructor() {
       super();
    }

    setTheme1(){this.dataContext.setTheme1();}
    setTheme2(){this.dataContext.setTheme2();}
    setTheme3(){this.dataContext.setTheme3();}
    setTheme4(){this.dataContext.setTheme4();}
    setTheme5(){this.dataContext.setTheme5();}
    setTheme6(){this.dataContext.setTheme6();}
    setTheme7(){this.dataContext.setTheme7();}
    setTheme8(){this.dataContext.setTheme8();}
    setTheme9(){this.dataContext.setTheme9();}
    setTheme10(){this.dataContext.setTheme10();}
    setTheme11(){this.dataContext.setTheme11();}
    setTheme12(){this.dataContext.setTheme12();}
    setTheme13(){this.dataContext.setTheme13();}
    setTheme14(){this.dataContext.setTheme14();}
    setTheme15(){this.dataContext.setTheme15();}

    closeThemeWindow(){
        this.dataContext.closeThemeWindow();   
    }
}
